module.exports = function(macrosites) {
	"use strict";
  macrosites
  .controller('macrositesFocusNewsController', macrositesFocusNewsController)
	macrositesFocusNewsController.$inject = ["config","API_URL","$http","$rootScope","getDataService","refreshtokenService","alertService","serverError", "offlineError"];
  function macrositesFocusNewsController(config,API_URL,$http,$rootScope,getDataService,refreshtokenService,alertService,serverError, offlineError) {
    var vmmfn = this;
    vmmfn.macrositesFocusNewsObj = {};
    vmmfn.addPostFromSearch = function(obj) {
      if(vmmfn.macrositesFocusNewsObj._id == obj.id) {
        alertService('danger', 'Opps! ', 'Post alredy exist!');
        return
      }
      vmmfn.macrositesFocusNewsObj = {
        '_id':obj.id,
        'title':obj.title,
        'url':obj.url,
        'image':obj.image,
      }
    }
    vmmfn.saveFocusNews = function() {
      var validation = true
      var putData;
      if(!vmmfn.macrositesFocusNewsObj) {
        alertService('danger','Opps! ', 'The post is required');
        validation = false
        return
      } else {
        putData = vmmfn.macrositesFocusNewsObj
      }
      if(!validation) return 
      // Get latest focus news data before saving
      $rootScope.hasLoaded = false;

      var updateFunction = function(url) {
        $rootScope.hasLoaded = false;
        $http.put(url , putData)
        .success(function (data, stat, headers) {
          $rootScope.hasLoaded = true;
          alertService('success','Success ', data.message, 2000);
        })
        .error(function (data, status, header, config) {
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  updateFunction(url);
                }
              },
              function(error) {
              },
              function(progress) {
                // report progress
            });
          }else if(status ==502) {
            serverError()  
          } else { 
            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        }); 
      }
      updateFunction(API_URL+ "macrosites/embed");
    }
    var getFocusNews = function() {
      $rootScope.hasLoaded = false;
      getDataService.get({param1:'macrosites', param2: 'embed'}).$promise.then(function(data){  
        $rootScope.hasLoaded = true;
        if(data.result) {
          vmmfn.macrositesFocusNewsObj = data.result
        }
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                getFocusNews();
              }
            },
            function(error) {
            },
            function(progress) {
             // report progress
          });
        } else if(error.status ==502) {
          serverError()
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        } 
        $rootScope.hasLoaded = true;
      });
    }
    getFocusNews()
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/macrositesModule/focusNews/js/macrositesFocusNewsController.js
// module id = 511
// module chunks = 0